import { CSSProperties, forwardRef } from 'react';
import * as S from './styles';
import { StaticImageData } from 'next/image';
import Text from '../Text';
import { useTheme } from 'styled-components';
import Cartaz from '../Cartaz';
import { IconeChippu } from '../Icones/IconeChippu';

export type ElencoProps = {
  $image?: string | StaticImageData;
  $nome?: string;
  $corNome?: string;
  $papel?: string;
  $corPapel?: string;
  $style?: CSSProperties;
};

const Elenco = forwardRef<HTMLDivElement, ElencoProps>((props, ref) => {
  const { $image, $nome, $corNome, $papel, $corPapel, $style, ...rest } = props;

  const theme = useTheme();

  return (
    <S.Container style={$style} ref={ref} {...rest}>
      <div
        style={{
          position: 'relative',
        }}
      >
        {!$image ? (
          <IconeChippu
            style={{
              position: 'absolute',
              top: '40%',
              left: '40%',
              zIndex: 10,
            }}
            size={32}
            color={theme.colors.neutral.neutral[9]}
          />
        ) : null}
        <Cartaz
          alt={`foto do ator ou atriz ${$nome}`}
          src={$image || ''}
          $tamanho="pequeno"
        />
      </div>

      {$nome ? (
        <Text
          $size={3}
          $utilizarReticencias
          $quebraTexto
          $color={$corNome || 'neutral'}
          $weight="bold"
          $align="left"
          $highContrast={true}
          $text={$nome}
          style={{
            marginTop: theme.spacing[3],
            alignSelf: 'flex-start',
          }}
        />
      ) : null}
      {$papel ? (
        <Text
          $size={3}
          $color={$corPapel || 'neutral'}
          $weight="regular"
          $align="left"
          $highContrast={true}
          $text={$papel}
          style={{
            marginTop: theme.spacing[1],
            alignSelf: 'flex-start',
            fontWeight: '400',
          }}
        />
      ) : null}
    </S.Container>
  );
});

Elenco.displayName = 'Elenco';

export default Elenco;
